
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistor02Off as ObiBipolar_transistor02OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-02-off.js';
 
 
 

 
 export const ObiBipolar_transistor02Off = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-02-off',
   elementClass: ObiBipolar_transistor02OffElement,
   events: {
     
   }
  });
 
 